var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EFF0FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10295_129233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.84 16.22C32.79 16.1 32.73 15.99 32.66 15.88C32.52 15.67 32.33 15.48 32.12 15.34C32.01 15.27 31.9 15.21 31.78 15.16C31.54 15.06 31.28 15 31 15H30V13H28V15H20V13H18V15H17C16.58 15 16.2 15.13 15.88 15.34C15.67 15.48 15.48 15.67 15.34 15.88C15.27 15.99 15.21 16.1 15.16 16.22C15.06 16.46 15 16.72 15 17V31C15 32.1 15.89 33 17 33H31C31.28 33 31.54 32.94 31.78 32.84C31.9 32.79 32.01 32.73 32.12 32.66C32.33 32.52 32.52 32.33 32.66 32.12C32.87 31.8 33 31.41 33 31V17C33 16.72 32.94 16.46 32.84 16.22ZM17 31V17H31V31H17ZM24 24.88C21.97 24.88 18 25.96 18 28.46V30H30V28.47C30 25.96 26.03 24.88 24 24.88ZM20.31 28C21 27.44 22.69 26.88 24 26.88C25.31 26.88 27.01 27.44 27.69 28H20.31ZM24 24C25.65 24 27 22.65 27 21C27 19.35 25.65 18 24 18C22.35 18 21 19.35 21 21C21 22.65 22.35 24 24 24ZM24 20C24.55 20 25 20.45 25 21C25 21.55 24.55 22 24 22C23.45 22 23 21.55 23 21C23 20.45 23.45 20 24 20Z",
    fill: "#6366F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10295_129233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentIcon);
export default __webpack_public_path__ + "static/media/assignmentIcon.6ee1661a420d122415ddb986ec56844d.svg";
export { ForwardRef as ReactComponent };